<template>
  <list-layout header="Produkte" :selected-item-id="selectedItemId" :items="sortedProducts" @select="select($event)">
    <template v-slot:up>
      <button class="btn btn-primary" @click="newProduct">Neues Produkt</button>
    </template>
    <template v-slot="{item}">
      <div class="row">
        <div class="col-12 col-md-10 d-flex">
          <cld-image class="img-fluid mr-2"
                     :public-id="item.imageId"
                     height="40"
                     width="auto"
                     crop="fit"/>
          <div>
            <div class="small">{{ item.id }}</div>
            <div class="font-weight-bolder">{{ item.name }}</div>
          </div>
        </div>
        <div class="col-12 col-md-2 text-right text-nowrap">
          <ProductCategory :category="item.category"/>
        </div>
      </div>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from "@/layouts/ListLayout";
import ProductCategory from "@/components/product/ProductCategory";

export default {
  data() {
    return {
      products: [],
      selectedProduct: null
    }
  },
  computed: {
    selectedItemId() {
      return this.selectedProduct?.id
    },
    sortedProducts() {
      return [...this.products].sort((p1, p2) => p1.category - p2.category)
    }
  },
  methods: {
    loadProducts() {
      this.$api.get('/products')
          .then(response => this.products = response.data.filter(p => p.category !== 'XTR'))
          .catch(err => this.handleError(err))
    },
    select(product) {
      this.selectedProduct = product
      const params = {}
      if(this.selectedProduct?.id)
        params.productId = this.selectedProduct.id
      this.$router.push({name: 'editProduct', params})
    },
    newProduct(){
      this.select()
    }
  },
  created() {
    this.loadProducts()
  },
  activated() {
    this.loadProducts()
  },
  components: {
    ProductCategory,
    ListLayout
  }
}

</script>
